import { render } from "./HeroiconsOutlineCurrencyDollar.vue?vue&type=template&id=d21a424a"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyDollar.vue"]])

export default __exports__